import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { nl } from "./nl";
import { nlStudio } from "./nlStudio";
import { nlLanding } from "./nlLanding";
import nlLanding2026 from "./nlLanding2026";
import { nlDemo } from "./nlDemo";
import { es } from "./es";
import { esSite } from "./esSite";

const LANGS = ["fr", "nl", "es"];
const DICTIONARIES = { nl: { ...nl, ...nlStudio, ...nlLanding, ...nlLanding2026, ...nlDemo }, es: { ...esSite, ...es } };
const LOCALES = { fr: "fr-BE", nl: "nl-BE", es: "es-ES" };

const LanguageContext = createContext({ lang: "fr", setLang: () => {}, t: (s) => s });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem("devisto_lang");
    return LANGS.includes(stored) ? stored : "fr";
  });

  const setLang = useCallback((l) => {
    const next = LANGS.includes(l) ? l : "fr";
    localStorage.setItem("devisto_lang", next);
    setLangState(next);
  }, []);

  useEffect(() => {
    document.documentElement.lang = LOCALES[lang] || LOCALES.fr;
  }, [lang]);

  const t = useCallback((frText) => DICTIONARIES[lang]?.[frText] ?? frText, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
